export const sanitiseKey = (key: string | number) => {
  return key
    .toString()
    .trim()
    .replace(/[^a-zA-Z0-9]/g, '_') // Replace non-alphanumeric characters with underscore
    .replace(/[-]/g, '_') // Replace dash with underscore
    .replace(/_+/g, '_') // Replace multiple consecutive underscores with a single one
    .toUpperCase();
};
